module.exports = __webpack_public_path__ + "img/otherpay-charge.a9155f43.svg";